module.exports = __webpack_public_path__ + "img/1493223172.27bbf6aa.jpg";